import styled from "styled-components";

export const FestivalCompetitionWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 100px;

  .no-data {
    width: 100%;
    text-align: center;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    margin-top: 140px;
    color: var(--Black-300, #808080);
  }
`;

export const RabbitFestivalCompetitionNewsWrapper = styled.div`
  padding: 0 16px;
`;
